import { useMelwaysLink } from '@seek/melways-react';
import { EMPLOYER_CONTACT_US_URL_PROPS } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Stack, Strong, Text, TextLink } from 'braid-design-system';

import translations from './.vocab';

export const UnexpectedError = () => {
  const { t } = useTranslations(translations);
  const contactUsUrl = useMelwaysLink(EMPLOYER_CONTACT_US_URL_PROPS);

  return (
    <Stack space="small">
      <Text>
        <Strong>{t('unexpected-error-title')}</Strong>
      </Text>
      <Text>{t('unexpected-error-text')}</Text>
      <Text>
        {t('unexpected-error-next-steps')}{' '}
        {t('unexpected-error-contact-cs', {
          CustomerServiceLink: (children) => (
            <TextLink href={contactUsUrl} target="_blank">
              {children}
            </TextLink>
          ),
        })}
      </Text>
    </Stack>
  );
};
